import Vue from 'vue'

const state = {
  imageSrc:null
}

const actions = {
  setImageModalSrc({ commit, state }, src){
    commit("updateImageSrc", src)
  }
}

const mutations = {
  updateImageSrc(state, data) {
    state.imageSrc = data
  }
}

const getters = {
  currentImageModalSrc(state) {
    return state.imageSrc
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/imagemodal.js